import { DisneySearchWidget } from '../../widgets/disney-search/disneySearchWidget';
import { WidgetsDeclaration } from '../../shared/interfaces/widgets-declaration';
import '../../shared/services/i18n';

declare let window: WidgetsDeclaration;
window.disneySearchWidget = DisneySearchWidget;
